import React, { useContext } from 'react';
export var Context = React.createContext(null);
export var ThemeProvider = _ref => {
  var {
    children,
    theme
  } = _ref;
  return React.createElement(Context.Provider, {
    value: theme
  }, children);
};
export var ThemeConsumer = Context.Consumer;
export var useTheme = () => {
  return useContext(Context);
};